import { ColumnType } from "antd/es/table";

import {
  getEnumKeys,
  REVERSE_ORDER_MAP,
  BidEntity,
  WalletRiskLevel,
  RISK_LEVELS,
  RISK_STATUS_TEXTS,
  RISK_LEVELS_FILTERS,
  REQUEST_CHECK_STATUS_ENUM,
  BidWalletCheckGridDto,
  RISK_STATUS_ENUM,
} from "interfaces";
import { Status, TxButton } from "ui";
import { dateFormat, EXPLORER_LINK_TYPE, getBlockchainExplorerLink, getFilterIcon, getSortIcon } from "utils";
import { DetailReportButton } from "pages/AmlChecksPage/DetailReport";
import { EmptyString } from "constants/strings";
import { BidWalletCheckList } from "stores/BidWalletCheckList";
import { Flex, Typography } from "antd";

export const getColumns = (
  checkList: BidWalletCheckList,
  bidCard: BidEntity
): Array<ColumnType<BidWalletCheckGridDto>> => {
  return [
    {
      dataIndex: "address",
      key: "address",
      title: "Адрес",
      width: 250,
      render: (_: any, record: BidWalletCheckGridDto) => {
        return record.address ? (
          <TxButton
            text={record.address}
            href={getBlockchainExplorerLink(bidCard.network, record.address, EXPLORER_LINK_TYPE.address)}
            isWalletAddress
            showCopyBtn
          />
        ) : (
          "Некорректный хеш"
        );
      },
    },
    {
      dataIndex: "created",
      key: "created",
      title: "Дата и время",
      sorter: { multiple: 3 },
      sortOrder: checkList?.sorters?.created && REVERSE_ORDER_MAP[checkList.sorters.created],
      sortIcon: getSortIcon,
      width: 250,
      render: (_: any, record: BidWalletCheckGridDto) => {
        return dateFormat(record.created, true);
      },
    },
    {
      dataIndex: "riskLevel",
      key: "riskLevelList",
      title: "Уровень риска",
      filterMultiple: true,
      defaultFilteredValue: checkList.queryParams["riskLevelList"],
      filtered: "riskLevelList" in checkList.queryParams,
      filters: getEnumKeys(RISK_LEVELS_FILTERS).map((key) => ({
        text: RISK_LEVELS.texts[key],
        value: key,
      })),
      width: 190,
      align: "left",
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      render: (riskLevel: WalletRiskLevel) => {
        return riskLevel ? (
          <Flex vertical align="start" gap="2px">
            <Status color={RISK_LEVELS.colors[riskLevel]} children={RISK_LEVELS.texts[riskLevel]} alignRight={false} />
            <Typography.Text className="text-description text-xs">Уровень риска</Typography.Text>
          </Flex>
        ) : (
          <Status color={"gray"} children={"Не проверялась"} alignRight={false} />
        );
      },
    },
    {
      dataIndex: "riskStatus",
      key: "riskStatusList",
      title: "Статус проверки",
      filterMultiple: true,
      defaultFilteredValue: checkList.queryParams["riskStatusList"],
      filtered: "riskStatusList" in checkList.queryParams,
      filters: getEnumKeys(REQUEST_CHECK_STATUS_ENUM).map((key) => ({
        text: RISK_STATUS_TEXTS[key],
        value: key,
      })),
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      width: 250,
      align: "left",
      render: (_: any, record: BidWalletCheckGridDto) => {
        if (record.riskStatus) {
          const approveNeeded = record.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED;
          return (
            <Flex vertical align="start" gap="2px">
              <Typography.Text>
                {approveNeeded ? "⚠️ Требует согласования" : RISK_STATUS_TEXTS[record.riskStatus]}
              </Typography.Text>
              <Typography.Text className="text-description text-xs">Статус проверки</Typography.Text>
            </Flex>
          );
        }

        return EmptyString;
      },
    },
    {
      dataIndex: "checkId",
      key: "checkId",
      title: "Детали проверки",
      width: 80,
      className: "text-align-right justify-self-end",
      render: (_: any, record: BidWalletCheckGridDto) => {
        return record.checkId ? <DetailReportButton checkId={record.checkId} type="wallet" /> : EmptyString;
      },
    },
  ].filter((c) => !!c) as Array<ColumnType<BidWalletCheckGridDto>>;
};
